import React from "react"
import { Link } from "gatsby"

import downloadIcon from "../../images/icon-download.png"
import rightArrow from "../../images/icon-ism-btn-arrow.svg"

const Button = ({
  className,
  type = false,
  copy,
  url,
  site="gist",
  buttontheme="yellow-sky-blue-navy",
  texttransform="none",
  target="_self",
  large=false,
  iconurl,
  alt,
  onclick
}) => {
  return (
    <>
      {!type && (
        <Link
          to={url}
          className={`btn ${site } ${buttontheme } ${className }`}
          target={target}
        >
          <div
            className={`btn-inner`} 
            style={{textTransform: `${texttransform}`}}
            >
            {copy}
          </div>
        </Link>   
      )}
      {type == "download" && (
        <Link
          to={url}
          className={`btn download ${site } ${className }`}
          target={target}
        >
          <div
            className={`btn-inner`} 
            style={{textTransform: `${texttransform}`}}
            >
              <div className="download-icon"><img src={downloadIcon} alt="Download file" /></div>
              <div>{copy}</div>
          </div>
        </Link>   
      )}
      {type == "ism-signup-btn" && (
        <Link
          to={url}
          className={`btn ism-signup-btn ${site } ${className }`}
          target={target}
        >
          <div
            className={`btn-inner`} 
            style={{textTransform: `${texttransform}`}}
            onClick={onclick}
            >
              <div>{copy}</div>
              <div className="right-arrow"><img src={rightArrow} alt="Submit" /></div>
          </div>
        </Link>   
      )}
      {type == "icon" && (
        <div
          className={`btn icon-only ${site } ${className }`}
        >
          <div
            className={`btn-inner ${buttontheme } `} >
              {iconurl && (
              <div className="icon"><img src={iconurl} alt={alt} /></div>
              )}
          </div>
        </div>   
      )}
      {type == "btn" && (
         <div
         className={`btn ${site } ${buttontheme } ${className }`}
         onClick={onclick}
       >
         <div
           className={`btn-inner`} 
           style={{textTransform: `${texttransform}`}}
           >
           {copy}
         </div>
       </div>  
      )}
    </>
  )
}

export default Button
